export enum ProductSpecification {
    LOW,
    MODERATE,
    VERY_HIGH,
}
